import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { isCollegeChallengeEnabled } from '../utils/collegeChallengeAccess';
import Dashboard from '../BasicComponents/Dashboard';
import Discover from '../BasicComponents/Discover';
import Contact from '../BasicComponents/Contact';
import Register from '../BasicComponents/Register';
import Login from '../BasicComponents/Login';
import Home from '../BasicComponents/Home';
import About from '../BasicComponents/About';
import ResetPassword from '../BasicComponents/ResetPassword';
import ForgotPassword from '../BasicComponents/ForgotPassword';
import LockedAccount from '../BasicComponents/LockedAccount';
import CleanProfile from '../BasicComponents/CleanProfile';
import EditProfile from '../BasicComponents/EditProfile';
import LevelTree from '../BasicComponents/SkillTree';
import Leaderboard from"../BasicComponents/Leaderboard";
import LevelClearance from"../BasicComponents/LevelClearance";
import FlipCardList from '../BasicComponents/FlipCardList';
import AdminDashboard from '../BasicComponents/AdminDashboard';
import QuestionPage from"../BasicComponents/QuestionPage";
import TechGrid from '../AdminComponents/TechGrid';
import Python from '../AdminComponents/Python';
import HuntLevel1 from '../CodeHunt/HuntLevel1';
import HuntLevel2 from '../CodeHunt/HuntLevel2';
import HuntLevel3 from '../CodeHunt/HuntLevel3';
import UserTypeSelector from '../BasicComponents/UserTypeSelector';
import CollegeRegister from '../BasicComponents/CollegeRegister';
import CollegeIntroPage from '../BasicComponents/CollegeIntroPage';
import SkillgenLaunchpad from"../AdminComponents/SkillgenLaunchpad";
import TrackQuestionPage from '../BasicComponents/TrackQuestionPage';
import CollegeHomePage from"../BasicComponents/CollegeHomePage";
import CollegeViewProfile from"../BasicComponents/CollegeViewProfile";
import CollegeEditProfile from"../BasicComponents/CollegeEditProfile";
import CollegeTotalStudents from"../BasicComponents/CollegeTotalStudents";
import CollegeStudentsProgress from"../BasicComponents/CollegeStudentsProgress";
import CollegeTopPerformers from"../BasicComponents/CollegeTopPerformers";
import CollegeFAQs from"../BasicComponents/CollegeFAQs";
import CollegeFeedbackInbox from"../BasicComponents/CollegeFeedbackInbox";
import CollegeLogoutFromThisDevice from"../BasicComponents/CollegeLogoutFromThisDevice";
import CollegeLogoutFromAllDevices from"../BasicComponents/CollegeLogoutFromAllDevices";
import CollegeCreditPurchase from"../BasicComponents/CollegeCreditPurchase";
import InstitutionalImpact from"../BasicComponents/InstitutionalImpact";
import Notes from"../BasicComponents/Notes";
import ContestPage from"../BasicComponents/ContestPage";
import Collegelogin from"../BasicComponents/Collegelogin";
import LaunchpadPage from '../BasicComponents/LaunchpadPage';
import SkillgenLaunchpadQuestionPage from"../BasicComponents/SkillgenLaunchpadQuestionPage";
import SkillgenLaunchpadLevels from '../BasicComponents/SkillgenLaunchpadLevels';
import SkillgenLaunchpadLevelClearance from '../BasicComponents/SkillgenLaunchpadLevelClearance';
import SupportTicketDashboard from '../AdminComponents/SupportTicketDashboard';
import AdminUsersDashboard from '../AdminComponents/AdminUsersDashboard';
import AdminCollegesDashboard from '../AdminComponents/AdminCollegesDashboard';
import AdminTechnologySelector from '../AdminComponents/AdminTechnologySelector';
import AdminQuestionManager from '../AdminComponents/AdminQuestionManager';
import SkillGenPaymentPage from '../BasicComponents/SkillGenPaymentPage';
import SkillgenproCompiler from '../components/SkillgenproCompiler';
import LaunchpadReader from"../components/LaunchpadReader";
import FeaturesOverview from '../BasicComponents/FeaturesOverview';
import TechTreeReader from"../components/TechTreeReader";
import SupportStudent from"../BasicComponents/SupportStudent";
import SupportCollege from"../BasicComponents/SupportCollege";
import LandingPage1 from '../BasicComponents/LandingPage1';
import LandingPage2 from '../BasicComponents/LandingPage2';
import PublicBookDemo from '../BasicComponents/PublicBookDemo';

//compiler pages
import LanguageGrid from"../BasicComponents/LanguageGrid";
import PracticeLevelPage from"../BasicComponents/PracticeLevelPage"; // create this component
import SolveCodingQuestionPage from"../BasicComponents/SolveCodingQuestionPage";
import Compiler from"../BasicComponents/Compiler";
import BootcampSelector from"../BasicComponents/learnerBootcampSelector";
import ThankYouPage from"../BasicComponents/ThankYouPage";
import Collegeforgotpassword from"../BasicComponents/collegeforgotpassword";
import Collegeresetpassword from"../BasicComponents/collegeresetpassword";
import LaunchpadHome from '../BasicComponents/LaunchpadHome';
import TopicContent from '../BasicComponents/TopicContent';
import CollegeDashboard from"../BasicComponents/CollegeDashboard";
import CollegeAnalyticsDashboard from '../CollegeComponents/CollegeAnalyticsDashboard';
import CollegeChallenge from '../CollegeComponents/CollegeChallenge';
import TopicExplorer from '../components/TopicExplorer';
import Bootcamp1 from '../components/learnerbootcamp1';
import TenantBootcampEnrollment from '../TenantDashboard/TenantBootcampEnrollment';
import UnifiedBootcampDashboard from '../components/learnerUnifiedBootcampDashboard';
import Technologyuserdashboard from "../components/learnertechnologyuserdashboard";
import Techbunchuserdashboard from '../components/learnertechbunchuserdashboard';
import Certifieduserdashboard from '../components/learnercertifieduserdashboard';

// ✅ Imported for Markdown Page
// import Sidebar1 from"../components/Sidebar1";
// import MarkdownViewer from"../components/MarkdownViewer";
// import ThemeToggle from"../components/ThemeToggle";
// import TopicExplorer from"../components/TopicExplorer";
import BulkEmailing from"../SuperAdminComponents/BulkEmailing"; // Importing BulkEmailing component
import SuperPayments from"../SuperAdminComponents/SuperPayments";
import SuperAdminLayout from"../SuperAdminComponents/SuperAdminLayout";
import TeeGeeLeads from "../SuperAdminComponents/TeeGeeLeads";
import EliteTechnologyManager from "../SuperAdminComponents/EliteTechnologyManager";
import EliteContentWorkspace from "../SuperAdminComponents/content/EliteContentWorkspace";
import ProjectsList from '../SuperAdminComponents/NextGenBuilder/ProjectsList';
import ProjectDetails from '../SuperAdminComponents/NextGenBuilder/ProjectDetails';
import VersionDetails from '../SuperAdminComponents/NextGenBuilder/VersionDetails';
import RolesManagement from '../SuperAdminComponents/NextGenBuilder/RolesManagement';
import TemplatesManagement from '../SuperAdminComponents/NextGenBuilder/TemplatesManagement';
// Both of these screens already existed and are already linked from the
// NextGen Builder header (ProjectsList.jsx:237 and :253) — they were simply
// never imported or given a <Route>, so every click landed on the SPA's
// catch-all 404 rather than the page that was sitting there ready to render.
import GitHubAccess from '../SuperAdminComponents/NextGenBuilder/GitHubAccess';
import NextGenFinance from '../SuperAdminComponents/NextGenBuilder/NextGenFinance';
import LeadAmbassadorDashboard from"../AdminComponents/LeadAmbassadorDashboard";
import TechExplorerHome from '../BasicComponents/TechExplorerHome';
import TechnologyDetail from '../BasicComponents/TechnologyDetail';
import TSGMyNotes from '../BasicComponents/Tsgmynotes';
import TSG from '../components/TSG';
import MyCertifications from '../pages/student/MyCertifications';
import NotFound from '../BasicComponents/NotFound';
import Adminroles from '../AdminComponents/adminroles';
import AdminProjectTeams from '../components/AdminProjectTeam';
import IndividualRoles from '../components/IndividualRoles';
import TeamRoles from '../components/TeamRoles';
import TeamLeaderboardPage from '../components/TeamLeaderboardPage';
import PaymentPage from '../components/PaymentPage';
import PaymentSuccess from '../components/PaymentSuccess';
import SubscriptionGuard from '../components/SubscriptionGuard';

// NextGen Builder Components
import { NextGenAuthProvider } from '../NextGenBuilder/context/NextGenAuthContext';
import NextGenRegister from '../NextGenBuilder/pages/NextGenRegister';
import NextGenLogin from '../NextGenBuilder/pages/NextGenLogin';
import NextGenForgotPassword from '../NextGenBuilder/pages/NextGenForgotPassword';
import NextGenResetPassword from '../NextGenBuilder/pages/NextGenResetPassword';
import NextGenDashboard from '../NextGenBuilder/pages/NextGenDashboard';
import NextGenProjectVersion from '../NextGenBuilder/pages/NextGenProjectVersion';
import NextGenEnrollment from '../NextGenBuilder/pages/NextGenEnrollment';
import NextGenProfile from '../NextGenBuilder/pages/NextGenProfile';
import NextGenPurchase from '../NextGenBuilder/pages/NextGenPurchase';
import NextGenPayment from '../NextGenBuilder/pages/NextGenPayment';
import NextGenPayments from '../NextGenBuilder/pages/NextGenPayments';
// TSG Nexus feature-based billing (26-Aug-2026)
import NextGenFeaturePlans from '../NextGenBuilder/pages/NextGenFeaturePlans';
import NextGenCart from '../NextGenBuilder/pages/NextGenCart';
import NextGenCheckout from '../NextGenBuilder/pages/NextGenCheckout';
import NextGenOrderDetail from '../NextGenBuilder/pages/NextGenOrderDetail';
import NexusBillingAdmin from '../SuperAdminComponents/NexusBillingAdmin';
import FeaturePricingAdmin from '../SuperAdminComponents/FeaturePricingAdmin';
import NextGenReferral from '../NextGenBuilder/pages/NextGenReferral';
import NextGenWallet from '../NextGenBuilder/pages/NextGenWallet';
import SupportNextGen from '../NextGenBuilder/pages/SupportNextGen';
import NextGenLayout from '../NextGenBuilder/components/NextGenLayout';
import NextGenThemeProvider from '../NextGenBuilder/components/NextGenThemeProvider';
import NextGenAuthThemeProvider from '../NextGenBuilder/components/NextGenAuthThemeProvider';
import NextGenPaidFeatureGuard from '../NextGenBuilder/components/NextGenPaidFeatureGuard';
import NextGenAITutorHub from '../NextGenBuilder/pages/NextGenAITutorHub';
import SubscriptionPlans from '../components/SubscriptionPlans';
import RoleDashboard from '../components/RoleDashboard';
import IndividualRoleViewer from '../components/IndividualRoleViewer';
import TeamRoleReplica from '../components/TeamRoleReplica';
import CertificatePage from '../components/CertificatePage';
import CertificateSystemDemo from '../components/CertificateSystemDemo';
import CertificatePreview from '../components/CertificatePreview';
import VoiceTrainingPage from '../pages/VoiceTrainingPage';

// Mock Interview pages
import CodingInterviewPage from '../components/MockInterview/CodingInterviewPage';
import MockTestPage from '../components/MockInterview/MockTestPage';
import MockResultsPage from '../components/MockInterview/MockResultsPage';
import MockInterviewHome from '../components/MockInterview/MockInterviewHome';
import PremiumInterviewView from '../components/Interview/PremiumInterviewView';
// import DiscountInterviewView from '../components/Interview/DiscountInterviewView';
import CodingInterviewView from '../components/Interview/CodingInterviewView';
import TechnicalInterviewRoom from '../components/MockInterview/TechnicalInterviewRoom';
import HRInterviewRoom from '../components/MockInterview/HRInterviewRoom';
import MockInterviewResult from '../components/MockInterview/MockInterviewResult';
import Timemanagequestionsmock from '../components/MockInterview/Timemanagequestionsmock';
import MockInterviewGrid from '../components/MockInterview/MockInterviewGrid';
import MockInterviewPayments from '../components/MockInterview/MockInterviewPayments';
import MockInterviewMyPaymentsHistory from '../components/MockInterview/MockInterviewMyPaymentsHistory';
import TSGNotes from '../BasicComponents/tsgnotes';
import TSGPromptPage from"../components/TSGPromptPage";
import ExplainPage from"../components/ExplainPage";
import ResumeReviewPage from"../components/ResumeReviewPage";
import InterviewPage from"../components/InterviewPage";
import CodeReviewPage from"../components/CodeReviewPage";
import SkillTestPage from"../components/SkillTestPage";
import ProjectBuilderPage from"../components/ProjectBuilderPage";
// import VoiceAssistant from '../BasicComponents/VoiceAssistant';
import TermsOfService from '../components/TermsOfService';
import PrivacyPolicy from '../components/PrivacyPolicy';
import CollegeStudentManagement from '../BasicComponents/CollegeStudentManagement';
import TenantManagement from '../SuperAdminComponents/TenantManagement';
import CertificateVerification from '../components/Certificate/CertificateVerification';
import MyCertificates from '../components/Certificate/MyCertificates';
import CollegeCertificateManagement from '../BasicComponents/CollegeCertificateManagement';
import TenantPortalHome from '../BasicComponents/TenantPortalHome';
import TenantAdminLogin from '../BasicComponents/TenantAdminLogin';
import TenantStudentLogin from '../BasicComponents/TenantStudentLogin';

// ── Tenant Student Dashboard ─────────────────────────────────────────────────
import TenantStudentAuthGuard from '../TenantDashboard/TenantStudentAuthGuard';
import TenantDashboardLayout from '../TenantDashboard/TenantDashboardLayout';
import TenantDashboardHome from '../TenantDashboard/TenantDashboardHome';
import MyBootcamps from '../TenantDashboard/MyBootcamps';
import TenantGitHubProfile from '../TenantDashboard/TenantGitHubProfile';
import CollegeGitHubDashboard from '../BasicComponents/CollegeGitHubDashboard';
import CollegeTransactionHistory from '../BasicComponents/CollegeTransactionHistory';
import EnterprisePurchasePage from '../BasicComponents/EnterprisePurchasePage';
import EnterprisePaymentsAdmin from '../SuperAdminComponents/EnterprisePaymentsAdmin';
import SalesTeamManagedPage from '../BasicComponents/SalesTeamManagedPage';

import AdminLayout from '../BasicComponents/AdminLayout';

// CRM Module (Super Admin only)
import CRMDashboard from '../SuperAdminComponents/crm/CRMDashboard';
import CRMContacts from '../SuperAdminComponents/crm/CRMContacts';
import CRMBulkUpload from '../SuperAdminComponents/crm/CRMBulkUpload';
import CRMSMS from '../SuperAdminComponents/crm/CRMSMS';
import CRMWhatsApp from '../SuperAdminComponents/crm/CRMWhatsApp';
import CRMVoiceCalling from '../SuperAdminComponents/crm/CRMVoiceCalling';
import CRMScheduleDemo from '../SuperAdminComponents/crm/CRMScheduleDemo';
import CRMDemoCalendar from '../SuperAdminComponents/crm/CRMDemoCalendar';
import CRMCommunicationHistory from '../SuperAdminComponents/crm/CRMCommunicationHistory';
import CRMAnalytics from '../SuperAdminComponents/crm/CRMAnalytics';
import CRMSettings from '../SuperAdminComponents/crm/CRMSettings';

// Tenant feature wrappers
import TenantMockInterviewHome from '../TenantDashboard/features/TenantMockInterviewHome';
import TenantTechExplorerHome from '../TenantDashboard/features/TenantTechExplorerHome';
import TenantTechnologyDetail from '../TenantDashboard/features/TenantTechnologyDetail';
import TenantLaunchpadHome from '../TenantDashboard/features/TenantLaunchpadHome';
import TenantLaunchpadContent from '../TenantDashboard/features/TenantLaunchpadContent';
import TenantTSG from '../TenantDashboard/features/TenantTSG';
import TenantTSGPromptPage from '../TenantDashboard/features/TenantTSGPromptPage';

// Elite Technology Mastery
import EliteTechnologyMastery from '../components/EliteTechnologyMastery';
import EliteTechnologyDetail from '../components/EliteTechnologyDetail';

// Detect if the current hostname is a tenant subdomain
// e.g. svecw.theskillgenie.com → true; theskillgenie.com → false
const BASE_DOMAIN = process.env.REACT_APP_BASE_DOMAIN || 'theskillgenie.com';

function isTenantSubdomain() {
  const hostname = window.location.hostname.toLowerCase();
  return (
    hostname !== BASE_DOMAIN &&
    hostname !== `www.${BASE_DOMAIN}` &&
    hostname !== 'localhost' &&
    !hostname.startsWith('127.') &&
    hostname.endsWith(`.${BASE_DOMAIN}`)
  );
}

/**
 * CollegeChallengeGuard
 *
 * Protects the /college-challenge route from being accessed by colleges
 * that are not among the first 100 registrants.
 *
 * Ineligible colleges are silently redirected to their dashboard, preventing
 * blank screens and infinite redirect loops.
 */
const CollegeChallengeGuard = ({ children }) => {
  if (isCollegeChallengeEnabled()) {
    return children;
  }
  // Redirect to the college dashboard (or root if no user stored)
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const username = user?.username;
  return <Navigate to={username ? `/collegehome/${username}` : '/'} replace />;
};

const AppRoutes = ({ chatBotRef, setShowChat }) => {
  const onTenantSubdomain = isTenantSubdomain();

  // ── TENANT PORTAL ROUTES ────────────────────────────────────────────
  // Shown when visiting a tenant subdomain (e.g. svecw.theskillgenie.com)
  // Shared routes (dashboard, college admin pages) remain accessible on both.
  if (onTenantSubdomain) {
    return (
      <Routes>
        {/* Tenant portal landing page */}
        <Route path="/" element={<TenantPortalHome />} />

        <Route path="/student/login" element={<TenantStudentLogin />} />
        <Route path="/admin/login" element={<TenantAdminLogin />} />

        {/* Catch-all for common learner routes on tenant subdomain — redirect to /dashboard */}
        <Route path="/mockinterviewhome" element={<Navigate to="/dashboard" replace />} />
        <Route path="/explore" element={<Navigate to="/dashboard" replace />} />
        <Route path="/launch" element={<Navigate to="/dashboard" replace />} />
        <Route path="/tsg" element={<Navigate to="/dashboard" replace />} />

        {/* Admin dashboard routes (same components, accessible from tenant domain) */}
        <Route path="/admin/dashboard" element={<CollegeDashboard />} />
        <Route path="/collegeabout" element={<CollegeDashboard />} />
        <Route path="/college-analytics" element={<CollegeAnalyticsDashboard />} />
        <Route path="/CollegeViewProfile" element={<CollegeViewProfile />} />
        <Route path="/CollegeEditProfile" element={<CollegeEditProfile />} />
        <Route path="/TotalStudents" element={<CollegeTotalStudents />} />
        <Route path="/StudentsProgress" element={<CollegeStudentsProgress />} />
        <Route path="/TopPerformers" element={<CollegeTopPerformers />} />
        <Route path="/CollegeFAQs" element={<CollegeFAQs />} />
        <Route path="/CollegeFeedback" element={<CollegeFeedbackInbox />} />
        <Route path="/CollegeLogoutFromThisDevice" element={<CollegeLogoutFromThisDevice />} />
        <Route path="/CollegeLogoutFromAllDevices" element={<CollegeLogoutFromAllDevices />} />
        <Route path="/college/purchase-credits" element={<CollegeCreditPurchase />} />
        <Route path="/college/subscription-managed" element={<SalesTeamManagedPage />} />
        <Route path="/college/transaction-history" element={<CollegeTransactionHistory />} />
        <Route path="/college/enterprise-purchase/:purchaseId" element={<EnterprisePurchasePage />} />
        <Route path="/college/student-management" element={<CollegeStudentManagement />} />
        <Route path="/college/certificates" element={<CollegeCertificateManagement />} />
        <Route path="/college/github" element={<CollegeGitHubDashboard />} />
        <Route path="/institutional-impact" element={<InstitutionalImpact />} />

        {/* Certificate Verification (Public Route - No Login Required) */}
        <Route path="/verify/:token" element={<CertificateVerification />} />

        {/* ── Tenant Student Dashboard (new, isolated experience) ─────── */}
        <Route
          path="/dashboard"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <TenantDashboardHome />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/dashboard"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <TenantDashboardHome />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/certifications"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <MyCertifications />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />

        {/* Profile pages — wrapped in TenantDashboardLayout for tenant students */}
        <Route
          path="/profile"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <CleanProfile />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/edit-profile"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <EditProfile />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />

        {/* Learning routes for tenant students — ALL wrapped in TenantDashboardLayout */}
        <Route
          path="/techgrid"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <TechGrid />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/practice/:technology"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <LevelTree />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/questions/:technology/:level"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <QuestionPage />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/levelclearance"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <LevelClearance />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/launchpadpage"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <LaunchpadPage />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/skillgenlaunchpadlevels"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <SkillgenLaunchpadLevels />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/skillgen-questions"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <SkillgenLaunchpadQuestionPage />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/skillgenlaunchpadclearance"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <SkillgenLaunchpadLevelClearance />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/topicexplorer"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <LaunchpadReader />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/compiler"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <Compiler />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/notes"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <Notes />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/tsgmynotes"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <TSGMyNotes />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/tsgnotes"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <TSGNotes />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/tsg"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <TenantTSG />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/tsg/explain"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <ExplainPage mode="tenant" />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/tsg/resume-review"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <ResumeReviewPage mode="tenant" />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/tsg/interview"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <InterviewPage mode="tenant" />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/tsg/code-review"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <CodeReviewPage mode="tenant" />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/tsg/skill-test"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <SkillTestPage mode="tenant" />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/tsg/project-builder"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <ProjectBuilderPage mode="tenant" />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/tsg/:intent"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <TenantTSGPromptPage />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/bootcamp"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <BootcampSelector />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        {/* Multi-enrollment routes — uses TenantBootcampEnrollment (student-specific form) */}
        <Route
          path="/bootcamp/enrollment"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <TenantBootcampEnrollment />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/bootcamp/my-bootcamps"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <MyBootcamps />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/github"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <TenantGitHubProfile />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/bootcamp-selector"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <Bootcamp1 />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/bootcampselector"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <Bootcamp1 />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/thankyou"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <ThankYouPage />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/mockinterviewhome"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <TenantMockInterviewHome />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/mockinterview/coding"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <CodingInterviewPage mode="tenant" />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/mockinterview/arithmetic"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <MockInterviewGrid mode="tenant" />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/mockinterview/technical"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <TechnicalInterviewRoom mode="tenant" />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/mockinterview/hr"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <HRInterviewRoom mode="tenant" />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/mockinterview/time_management"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <Timemanagequestionsmock />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/mock-test/:topicTitle"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <MockTestPage mode="tenant" />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/mock-result"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <MockResultsPage mode="tenant" />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/interview-result"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <MockInterviewResult mode="tenant" />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/mockinterview/result"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <MockInterviewResult mode="tenant" />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/practice/:technology"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <LevelTree />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/skillgenlaunchpadlevels"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <SkillgenLaunchpadLevels />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/skillgen-questions"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <SkillgenLaunchpadQuestionPage />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/explore"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <TenantTechExplorerHome />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/explore/:slug"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <TenantTechnologyDetail />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/launch"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <TenantLaunchpadHome />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/student/launch/:track/:subtopic"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <TenantLaunchpadContent />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/mockinterviewpayments"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <MockInterviewPayments />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/mockinterviewpayments_history"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <MockInterviewMyPaymentsHistory />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/mockinterview/result"
          element={
            <MockInterviewResult />
          }
        />
        <Route
          path="/interview-result"
          element={
            <MockInterviewResult />
          }
        />
        <Route
          path="/bootcamp1"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <Bootcamp1 />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        {/* ── Bootcamp roles dashboard routes ── */}
        <Route
          path="/individual-roles"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <IndividualRoles />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/team-roles"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <TeamRoles />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/team-leaderboard"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <TeamLeaderboardPage />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/role-dashboard"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <RoleDashboard />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/individual-role-viewer"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <IndividualRoleViewer />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/team-role-replica"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <TeamRoleReplica />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/bootcamp/certificate"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <CertificatePage />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/certificate-preview"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <CertificatePreview />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/techbunchuserdashboard"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <Techbunchuserdashboard />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/techuserdashboard"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <Technologyuserdashboard />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/certifieduserdashboard"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <Certifieduserdashboard />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/support-student"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <SupportStudent />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/techmcq"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <TopicExplorer />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />

        {/* Password reset (needed on tenant domain) */}
        <Route path="/collegeforgotpass" element={<Collegeforgotpassword />} />
        <Route path="/collegereset/:token" element={<Collegeresetpassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />

        {/* Support */}
        <Route path="/support-college" element={<SupportCollege />} />

        {/* College home (after "Go to Dashboard") */}
        <Route path="/collegehome/:username" element={<CollegeHomePage />} />
        <Route
          path="/college-challenge"
          element={
            <CollegeChallengeGuard>
              <CollegeChallenge />
            </CollegeChallengeGuard>
          }
        />

        {/* Bootcamp roles-track dashboard — redirect to student dashboard */}
        <Route
          path="/dashboard"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <TenantDashboardHome />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />

        {/* Subscription/payment page — safety net if any component redirects here */}
        <Route
          path="/skillgenpayments"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <SubscriptionPlans />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />

        {/* Elite Technology Mastery */}
        <Route
          path="/elite-mastery"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <EliteTechnologyMastery />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />
        <Route
          path="/elite-mastery/:tech"
          element={
            <TenantStudentAuthGuard>
              <TenantDashboardLayout>
                <EliteTechnologyDetail />
              </TenantDashboardLayout>
            </TenantStudentAuthGuard>
          }
        />

        {/* Fallback → portal home */}
        <Route path="*" element={<TenantPortalHome />} />
      </Routes>
    );
  }

  // ── PUBLIC / MAIN DOMAIN ROUTES ─────────────────────────────────────
 return (
 <Routes>
 <Route path="/" element={<Home />} />
 <Route path="/collegeabout" element={<CollegeDashboard />} />
 <Route path="/college-analytics" element={<CollegeAnalyticsDashboard />} />
 {/* Tenant portal routes — redirect to collegesignup if accessed from main domain */}
 <Route path="/admin/login" element={<CollegeRegister />} />
 <Route path="/student/login" element={<Login />} />
 <Route path="/techmcq" element={<TopicExplorer/>} />
 <Route path="/discover" element={<Discover />} />
 <Route path="/contact" element={<Contact />} />
 <Route path="/register" element={<Register />} />
 <Route path="/login" element={<Login />} />
 <Route path="/about" element={<About />} />
 <Route path="/book-demo" element={<PublicBookDemo />} />
 <Route path="/reset-password/:token" element={<ResetPassword />} />
 <Route path="/forgot-password" element={<ForgotPassword />} />
 <Route path="/account-locked" element={<LockedAccount />} />
{/* <Route path="/support" element={<Support />} /> */}
 <Route path="/dashboard" element={<Dashboard />} />
 <Route path="/profile" element={<CleanProfile />} />
 <Route path="/practice/:technology" element={<LevelTree />} />
 <Route path="/leaderboard" element={<Leaderboard />} />
 <Route path="/levelclearance" element={<LevelClearance />} />
 <Route path="/code-hunt" element={<FlipCardList />} />
 <Route path="/admin" element={<AdminDashboard />} />
 <Route path="/techgrid" element={<TechGrid />} />
 <Route path="/python" element={<Python />} />
 <Route path="/questions/:technology/:level" element={<QuestionPage />} />
 <Route path="/level1" element={<HuntLevel1 />} />
 <Route path="/level2" element={<HuntLevel2 />} />
 <Route path="/level3" element={<HuntLevel3 />} />
 <Route path="/usertype" element={<UserTypeSelector />} />
 <Route path="/college-intro" element={<CollegeIntroPage />} />
 <Route path="/collegesignup" element={<CollegeRegister />} />
 <Route path="/skillgenlaunchpad" element={<SkillgenLaunchpad />} />

 {/* NextGen Builder Public Routes */}
 <Route path="/nextgen-builder/register" element={<NextGenAuthProvider><NextGenAuthThemeProvider><NextGenRegister /></NextGenAuthThemeProvider></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/login" element={<NextGenAuthProvider><NextGenAuthThemeProvider><NextGenLogin /></NextGenAuthThemeProvider></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/forgot-password" element={<NextGenAuthProvider><NextGenAuthThemeProvider><NextGenForgotPassword /></NextGenAuthThemeProvider></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/reset-password/:token" element={<NextGenAuthProvider><NextGenAuthThemeProvider><NextGenResetPassword /></NextGenAuthThemeProvider></NextGenAuthProvider>} />

 {/* NextGen Builder Protected Routes */}
 <Route path="/nextgen-builder/dashboard" element={<NextGenAuthProvider><NextGenLayout><NextGenDashboard /></NextGenLayout></NextGenAuthProvider>} />
 {/* Per-version detail page — the "Open Dashboard" button on each version
     card in NextGenDashboard navigates here with the version's numeric id.
     The param is named :versionId (not :id) to match NextGenProjectVersion's
     existing useParams() destructure without touching that file. */}
 <Route path="/nextgen-builder/dashboard/project/:versionId" element={<NextGenAuthProvider><NextGenLayout><NextGenProjectVersion /></NextGenLayout></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/profile" element={<NextGenAuthProvider><NextGenLayout><NextGenProfile /></NextGenLayout></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/enrollment" element={<NextGenAuthProvider><NextGenLayout><NextGenEnrollment /></NextGenLayout></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/purchase" element={<NextGenAuthProvider><NextGenLayout><NextGenPurchase /></NextGenLayout></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/payment/:planId" element={<NextGenAuthProvider><NextGenLayout><NextGenPayment /></NextGenLayout></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/payments" element={<NextGenAuthProvider><NextGenLayout><NextGenPayments /></NextGenLayout></NextGenAuthProvider>} />
 {/* Feature-based billing: per-feature credits, cart, checkout, orders */}
 <Route path="/nextgen-builder/plans" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><NextGenFeaturePlans /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/cart" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><NextGenCart /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/checkout" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><NextGenCheckout /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/orders/:orderId" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><NextGenOrderDetail /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/refer" element={<NextGenAuthProvider><NextGenLayout><NextGenReferral /></NextGenLayout></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/wallet" element={<NextGenAuthProvider><NextGenLayout><NextGenWallet /></NextGenLayout></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/support" element={<NextGenAuthProvider><NextGenLayout><SupportNextGen /></NextGenLayout></NextGenAuthProvider>} />

 {/* ── NextGen Builder / TSG Nexus — reused learner modules ──────────────
     AI Tutor, Elite Mastery and Mock Interview are NOT reimplemented here.
     Every route below renders the SAME components already live in the main
     learner app (ExplainPage, InterviewPage, EliteTechnologyMastery,
     MockInterviewHome, etc. — see imports above), reusing their existing
     APIs, services and business logic unmodified. `mode="tenant"` reuses
     the existing external-gating bypass (the same one TenantDashboard uses)
     since access here is gated by NextGenPaidFeatureGuard instead of the
     learner subscription paywall. Since the feature-based billing launch
     (26-Aug-2026) these routes only require a signed-in builder: each
     feature has a free allowance and its own paid credits, enforced
     server-side — see NextGenPaidFeatureGuard. */}

 {/* AI Tutor */}
 <Route path="/nextgen-builder/ai-tutor" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><NextGenAITutorHub /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/ai-tutor/notes" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><TSG mode="tenant" /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/ai-tutor/explain" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><ExplainPage mode="tenant" /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/ai-tutor/resume-review" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><ResumeReviewPage mode="tenant" /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/ai-tutor/interview" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><InterviewPage mode="tenant" /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/ai-tutor/code-review" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><CodeReviewPage mode="tenant" /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/ai-tutor/skill-test" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><SkillTestPage mode="tenant" /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/ai-tutor/project-builder" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><ProjectBuilderPage mode="tenant" /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/ai-tutor/:intent" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><TSGPromptPage mode="tenant" /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />

 {/* Elite Mastery */}
 <Route path="/nextgen-builder/elite-mastery" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><EliteTechnologyMastery mode="tenant" /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/elite-mastery/:tech" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><EliteTechnologyDetail mode="tenant" /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />

 {/* Mock Interview */}
 <Route path="/nextgen-builder/mock-interview" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><MockInterviewHome mode="tenant" /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/mock-interview/coding" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><CodingInterviewPage mode="tenant" /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/mock-interview/arithmetic" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><MockInterviewGrid mode="tenant" /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/mock-interview/technical" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><TechnicalInterviewRoom mode="tenant" /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/mock-interview/hr" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><HRInterviewRoom mode="tenant" /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/mock-interview/time_management" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><Timemanagequestionsmock mode="tenant" /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/mock-interview/mock-test/:topicTitle" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><MockTestPage mode="tenant" /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/mock-interview/result" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><MockInterviewResult mode="tenant" /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />
 <Route path="/nextgen-builder/mock-interview/mock-result" element={<NextGenAuthProvider><NextGenPaidFeatureGuard><NextGenLayout><MockResultsPage mode="tenant" /></NextGenLayout></NextGenPaidFeatureGuard></NextGenAuthProvider>} />

 <Route path="/launchpad/:track" element={<TrackQuestionPage />} />
 <Route path="/mockinterviewpayments_history" element={<MockInterviewMyPaymentsHistory />} />
 <Route path="/mockinterviewpayments" element={<MockInterviewPayments />} />
 <Route path="/mockinterviewhome" element={<MockInterviewHome />} />
 <Route path="/premium-interview" element={<PremiumInterviewView userId={localStorage.getItem('user_id')} technology="Java" experience="Junior" interviewType="Technical" />} />
 {/* <Route path="/discount-interview" element={<DiscountInterviewView userId={localStorage.getItem('user_id')} technology="Java" experience="Junior" />} /> */}
 <Route path="/coding-interview" element={<CodingInterviewView userId={localStorage.getItem('user_id')} technology="Java" experience="Junior" />} />
        <Route path="/mockinterview/coding" element={<CodingInterviewPage />} />
        <Route path="/mockinterview/arithmetic" element={<MockInterviewGrid />} />
        <Route path="/mockinterview/technical" element={<TechnicalInterviewRoom />} />
        <Route path="/mockinterview/hr" element={<HRInterviewRoom />} />
        <Route path="/mockinterview/time_management" element={<Timemanagequestionsmock />} />
        <Route path="/mockinterview/mock-test/:topicTitle" element={<MockTestPage />} />
        <Route path="/mockinterview/mock-result" element={<MockResultsPage />} />
        <Route path="/interview-result" element={<MockInterviewResult />} />
 <Route path="/collegehome/:username" element={<CollegeHomePage />} />
 <Route path="/CollegeViewProfile" element={<CollegeViewProfile />} />
 <Route path="/CollegeEditProfile" element={<CollegeEditProfile />} />
 <Route path="/TotalStudents" element={<CollegeTotalStudents />} />
 <Route path="/StudentsProgress" element={<CollegeStudentsProgress />} />
 <Route path="/TopPerformers" element={<CollegeTopPerformers />} />
 <Route path="/CollegeFAQs" element={<CollegeFAQs />} />
 <Route path="/CollegeFeedback" element={<CollegeFeedbackInbox />} />
 <Route path="/CollegeLogoutFromThisDevice" element={<CollegeLogoutFromThisDevice />} />
 <Route path="/CollegeLogoutFromAllDevices" element={<CollegeLogoutFromAllDevices />} />
 <Route path="/college/purchase-credits" element={<CollegeCreditPurchase />} />
 <Route path="/college/subscription-managed" element={<SalesTeamManagedPage />} />
 <Route path="/college/transaction-history" element={<CollegeTransactionHistory />} />
 <Route path="/college/enterprise-purchase/:purchaseId" element={<EnterprisePurchasePage />} />
 <Route path="/college/student-management" element={<CollegeStudentManagement />} />
 <Route path="/college/certificates" element={<CollegeCertificateManagement />} />
 <Route path="/college/github" element={<CollegeGitHubDashboard />} />
 <Route path="/institutional-impact" element={<InstitutionalImpact />} />
 <Route path="/edit-profile" element={<EditProfile />} />
 <Route path="/notes" element={<Notes />} />
 <Route path='/tsgmynotes' element={<TSGMyNotes />} />
 <Route path='/tsgnotes' element={<TSGNotes />} />
 <Route path="/contest" element={<ContestPage />} />
 <Route path="/collegelogin" element={<Collegelogin />} />
 <Route path="/launchpadpage" element={<LaunchpadPage />} />
 <Route path="/skillgen-questions" element={<SkillgenLaunchpadQuestionPage />} />
 <Route path="/skillgenlaunchpadlevels" element={<SkillgenLaunchpadLevels />} />
 <Route path="/skillgenlaunchpadclearance" element={<SkillgenLaunchpadLevelClearance />} />
 <Route path="/supporttickets" element={<SupportTicketDashboard />} />
 <Route path="/adminusersdashboard" element={<AdminUsersDashboard />} />
 <Route path="/admincollegesdashboard" element={<AdminCollegesDashboard />} />
 <Route path="/admin-console/lead-ambassadors" element={<LeadAmbassadorDashboard />} />
 <Route path="/admintechgrid" element={<AdminTechnologySelector />} />
 <Route path="/admin/manage-questions/:technology" element={<AdminQuestionManager />} />
 <Route path="/skillgenpayment" element={<SkillGenPaymentPage />} />

 <Route path="/chatbot" element={<SkillgenproCompiler chatBotRef={chatBotRef} setShowChat={setShowChat} />} />
 <Route path="/topicexplorer" element={<LaunchpadReader />} />
 <Route path="/tech-tree-reader" element={<TechTreeReader />} />
 <Route path="/elite-mastery" element={<EliteTechnologyMastery />} />
 <Route path="/elite-mastery/:tech" element={<EliteTechnologyDetail />} />
   <Route path="/nextgen/projects"               element={<ProjectsList />} />
   <Route path="/nextgen/projects/:id"           element={<ProjectDetails />} />
   <Route path="/nextgen/versions/:id"           element={<VersionDetails />} />
   <Route path="/nextgen/roles"                  element={<RolesManagement />} />
   <Route path="/nextgen/templates"              element={<TemplatesManagement />} />
   <Route path="/nextgen/github-access"          element={<GitHubAccess />} />
   <Route path="/nextgen/finance"                element={<NextGenFinance />} />
   {/* Full-screen Elite content workspace (deliberately outside SuperAdminLayout: dedicated reading/editing surface) */}
   <Route path="/superadmin/elite-technologies/content/:contentId" element={<EliteContentWorkspace />} />
   <Route element={<SuperAdminLayout />}>
     <Route path="/superadmin/tenants"                        element={<TenantManagement />} />
     <Route path="/superadmin/lead-ambassadors"               element={<LeadAmbassadorDashboard />} />
     <Route path="/superadmin/tee-gee-leads"                  element={<TeeGeeLeads />} />
     <Route path="/superadmin/elite-technologies"              element={<EliteTechnologyManager />} />
     <Route path="/superadmin/feature-pricing"                 element={<FeaturePricingAdmin />} />
     <Route path="/superadmin/nexus-billing"                   element={<NexusBillingAdmin />} />
     <Route path="/bulkemailing"                              element={<BulkEmailing />} />
     <Route path="/superpayments"                             element={<SuperPayments />} />
   </Route>

 {/* Finance + CRM — wrapped in AdminLayout (purple dashboard sidebar) */}
 <Route element={<AdminLayout />}>
   <Route path="/superadmin/finance/enterprise-payments"    element={<EnterprisePaymentsAdmin />} />

   {/* CRM Module — Super Admin only */}
   <Route path="/superadmin/crm"                            element={<CRMDashboard />} />
   <Route path="/superadmin/crm/contacts"                   element={<CRMContacts />} />
   <Route path="/superadmin/crm/bulk-upload"                element={<CRMBulkUpload />} />
   <Route path="/superadmin/crm/sms"                        element={<CRMSMS />} />
   <Route path="/superadmin/crm/whatsapp"                   element={<CRMWhatsApp />} />
   <Route path="/superadmin/crm/voice"                      element={<CRMVoiceCalling />} />
   <Route path="/superadmin/crm/demos"                      element={<CRMScheduleDemo />} />
   <Route path="/superadmin/crm/calendar"                   element={<CRMDemoCalendar />} />
   <Route path="/superadmin/crm/history"                    element={<CRMCommunicationHistory />} />
   <Route path="/superadmin/crm/analytics"                  element={<CRMAnalytics />} />
   <Route path="/superadmin/crm/settings"                   element={<CRMSettings />} />
 </Route>
 <Route path="/bootcamp" element={< BootcampSelector/>} />
 <Route path="/bootcamp-selector" element={<Bootcamp1 />} />
 <Route path="/bootcampselector" element={<Bootcamp1 />} />
 <Route path="/thankyou" element={<ThankYouPage />} />

 <Route path="/languagegrid" element={<LanguageGrid />} />
 <Route path="/practices/:language/:level" element={<PracticeLevelPage />} />
 <Route path="/practices/:language/:level/:questionId" element={<SolveCodingQuestionPage />} />
 <Route path="/compiler" element={<Compiler />} />
 <Route path="/tsg" element={<TSG />} />
 <Route path="/tsg/:intent" element={<TSGPromptPage />} />
 <Route path="/tsg/explain" element={<ExplainPage />} />
 <Route path="/tsg/resume-review" element={<ResumeReviewPage />} />
 <Route path="/tsg/interview" element={<InterviewPage />} />
 <Route path="/tsg/code-review" element={<CodeReviewPage />} />
 <Route path="/tsg/skill-test" element={<SkillTestPage />} />
 <Route path="/tsg/project-builder" element={<ProjectBuilderPage />} />
 <Route path="/features" element={<FeaturesOverview />} />
 <Route path="/collegeforgotpass" element={<Collegeforgotpassword />} />
 <Route path="/collegereset/:token" element={<Collegeresetpassword />} />
 <Route path="/launch" element={<LaunchpadHome />} />
 <Route path="/launch/:track/:subtopic" element={<TopicContent />} />
 <Route path="/explore" element={<TechExplorerHome />} />
 <Route path="/explore/:slug" element={<TechnologyDetail />} />
 <Route path="/support-student" element={<SupportStudent />} />
 <Route path="/support-college" element={<SupportCollege />} />
 <Route path="/landingpage1" element={<LandingPage1 />} />
 <Route path="/landingpage2" element={<LandingPage2 />} />
 <Route path="/bootcamp1" element={<Bootcamp1/>} />
 <Route path="/bootcamp/enrollment" element={<Bootcamp1/>} />
 <Route path="/bootcamp/my-bootcamps" element={
 <SubscriptionGuard>
 <MyBootcamps />
 </SubscriptionGuard>
 } />
 <Route path="/bootcamp/dashboard" element={
 <SubscriptionGuard>
 <UnifiedBootcampDashboard />
 </SubscriptionGuard>
 } />
 {/* Bootcamp Dashboards - Using existing working dashboards */}
 <Route path="/techuserdashboard" element={
 <SubscriptionGuard>
 <Technologyuserdashboard />
 </SubscriptionGuard>
 } />
 <Route path="/techbunchuserdashboard" element={
 <SubscriptionGuard>
 <Techbunchuserdashboard />
 </SubscriptionGuard>
 } />
 <Route path="/certifieduserdashboard" element={
 <SubscriptionGuard>
 <Certifieduserdashboard />
 </SubscriptionGuard>
 } />
 <Route path="/adminroles" element={<Adminroles />} />
 <Route path="/admin1" element={<AdminProjectTeams />} />
 <Route path="/individual-roles" element={
 <SubscriptionGuard>
 <IndividualRoles />
 </SubscriptionGuard>
 } />
 <Route path="/team-roles" element={
 <SubscriptionGuard>
 <TeamRoles />
 </SubscriptionGuard>
 } />
 <Route path="/team-leaderboard" element={
 <SubscriptionGuard>
 <TeamLeaderboardPage />
 </SubscriptionGuard>
 } />
 <Route path="/payment" element={<PaymentPage />} />
 <Route path="/payment-success" element={<PaymentSuccess />} />
 <Route path="/subscription-plans" element={<SubscriptionPlans />} />
 <Route path="/role-dashboard" element={<RoleDashboard />} />
 <Route path="/individual-role-viewer" element={<IndividualRoleViewer />} />
 <Route path="/team-role-replica" element={<TeamRoleReplica />} />
 <Route path="/bootcamp/certificate" element={<CertificatePage />} />
 <Route path="/certificate-demo" element={<CertificateSystemDemo />} />
 <Route path="/certificate-preview" element={<CertificatePreview />} />
 <Route path="/voice-training" element={<VoiceTrainingPage />} />

 {/* Legal Pages */}
 <Route path="/terms-of-service" element={<TermsOfService />} />
 <Route path="/privacy-policy" element={<PrivacyPolicy />} />

 {/* Certificate Verification (Public Route - No Login Required) */}
 <Route path="/verify/:token" element={<CertificateVerification />} />

  {/* Universal subscription/payment route - works for all premium features */}
  <Route path="/skillgenpayments" element={<SubscriptionPlans />} />

  <Route path="*" element={<NotFound />} />
</Routes>
 );
};

// ✅ END of functional component
export default AppRoutes;